import Firebase from '../../../lib/Firebase';
import Firestore from '../../../lib/Firestore';

export default {
  all(city) {
    return Firebase.firestore()
      .collection('cities')
      .doc(city)
      .collection('banners')
      .get()
      .then(docs => {
        return Firestore.getCollectionData(docs);
      });
  },

  add(city, banner) {
    const bannerObj = {
      title: banner
    };

    return Firebase.firestore()
      .collection('cities')
      .doc(city)
      .collection('banners')
      .add(bannerObj);
  },

  deleteBanner(city, banner) {
    return Firebase.firestore()
      .collection('cities')
      .doc(city)
      .collection('banners')
      .doc(banner)
      .delete();
  }
};



// WEBPACK FOOTER //
// ./src/pages/cities/Banners/service.js